import { Doughnut, mixins } from 'vue-chartjs'
import ChartDataLabels from 'chartjs-plugin-datalabels';

const { reactiveProp } = mixins

export default {
  extends: Doughnut,
  mixins: [reactiveProp],
  data () {
    return {
    }
  },
  props: {
    options: {
      type: Object
    },
    gradiente: {
      type: Boolean,
      default: true
    },
    coloredLine: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    if (this.$refs.canvas) {
      this.addPlugin(ChartDataLabels);
      this.renderChart(
        this.chartData,
        this.options
      )
      this.htmlLegend = this.generateLegend()
    }
  },
  methods: {
    montarCor (cor) {
      if (this.gradiente) {
        return this.gradient(cor)
      } else {
        return 'rgb(' + cor + ')'
      }
    },
    gradient (color) {
      var gradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450)

      gradient.addColorStop(0, 'rgba(' + color + ', 1)')
      gradient.addColorStop(0.5, 'rgba(' + color + ', 0.6)')
      gradient.addColorStop(1, 'rgba(' + color + ', 0.2)')

      return gradient
    }
  },
  watch: {
    chartData () {
      this.$data._chart.update()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/common/DoughnutChart.js